'use strict'

module.exports = {
  NODE_ENV: process.env.NODE_ENV || 'production',
  API: process.env.API,
  SOCKET_URL: process.env.SOCKET_URL
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1